module.exports = __webpack_public_path__ + "static/bee-eb4c3e17944984aee82cf0f8eb72a696.png";